import { render, staticRenderFns } from "./BuyListViewDetail.vue?vue&type=template&id=e761892a&scoped=true&"
import script from "./BuyListViewDetail.vue?vue&type=script&lang=js&"
export * from "./BuyListViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyListViewDetail.vue?vue&type=style&index=0&id=e761892a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e761892a",
  null
  
)

export default component.exports